import { Col, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import { useRef, useState } from "react";
import downloadImg from '../../assets/images/Dashboard/downloadImg.svg'

const ViewStockIndicatorModal = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    // Handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            console.log('Selected file:', file);
        }
    };

    // Trigger file input click when attachment button is clicked
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };
    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Stock Indicator</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={12}>
                                    <div className="view-sla-data">
                                        <label className="pb-2 pt-2">SSI Description</label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pb-2 pt-2">SSI Key </label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pb-2 pt-2">GL Account</label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="view-sla-data">
                                        <label className="pb-2 pt-2">Expensed</label>
                                        <span className="description-text"></span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pb-2 pt-2">Status</label>
                                        <span className="description-text"></span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewStockIndicatorModal;